import React from 'react';
import DeliveryFollow from '../DeliveryFollowForm/DeliveryFollowForm';
// import image from '../../../assets/image/bg-login.png';

const Landing = () => {
  return (
    <div className="landing-bg">
      <DeliveryFollow />
    </div>
  );
};

export default Landing;
